"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.peanutsToClient = peanutsToClient;
function peanutsToClient(peanuts) {
    return peanuts ? Number.parseFloat(peanuts.toFixed(2)) : 0;
}
